import { Outlet } from 'react-router-dom';
import { CartDrawer } from '@kss/ui';
import { SessionEndedBanner, SessionTimeoutModal, useAuth } from '@kss/auth';
import { WebHeader } from './WebHeader';
import { WebFooter } from './WebFooter';

export function WebLayout() {
  // Cart is a logged-in-only feature: hide the drawer entirely for guests.
  // Add-to-cart entry points are gated separately to dispatch the login modal.
  const { isAuthenticated } = useAuth();
  return (
    /* `overflow-x-hidden` MOVED from the root to `<main>` (2026-05-21).
       Any non-`visible` overflow on an ancestor breaks `position:
       sticky` on descendants — the sticky element gets pinned to the
       scrolling ancestor instead of the viewport. With the rule on the
       root, the sticky header stopped showing on scroll. Putting the
       clip on `<main>` alone:
         - keeps the full-bleed hero slider's `w-screen` from
           introducing a horizontal scrollbar (still clipped inside
           main), AND
         - leaves the header (sibling of main) in the document's
           natural scroll context so `sticky top-0` works again.
    */
    <div className="flex min-h-screen w-full max-w-full flex-col bg-[var(--color-bg-app)] text-[var(--color-text-primary)]">
      <SessionEndedBanner />
      <WebHeader />
      {/* 1px gap between the sticky menu bar and the page banner /
          hero per user request 2026-05-21 — tightest visible spacing
          so the slider sits flush below the header.
          `min-w-0` lets <main> shrink to fit narrow viewports so a
          single overflowing child can't introduce a horizontal
          scrollbar that pushes the footer off-screen. */}
      <main className="w-full min-w-0 flex-1 overflow-x-hidden" style={{ marginTop: 1 }}>
        <Outlet />
      </main>
      <WebFooter />
      {isAuthenticated && <CartDrawer />}
      {/* Inactivity-warning modal — only renders when authenticated AND
          idle for IDLE_WARN_AFTER_MS. The hook inside the modal is a
          no-op for logged-out browsers, so guests pay no cost. */}
      <SessionTimeoutModal />
    </div>
  );
}

export default WebLayout;
